import React from "react";
import "./Programs.css";
import { Container, Row, Col } from "react-bootstrap";
import arrowImage from "../../Images/programs/arrow.webp";
import Certificate from "../../Images/programs/Certificate.webp";
import diploma from "../../Images/programs/diploma.webp";
import Graduation from "../../Images/programs/Graduation.webp";
import Post from "../../Images/programs/Post-Graduation.webp";
import Research from "../../Images/programs/Research-and-Development.webp";

const Programs = () => {
  return (
    <section className="programs-section ptb-50">
      <div className="container-xxl">
        <Row className="m-0">
          <Col md={6} className="programs-text-col d-flex flex-column">
            <h2 className="modern-title mb-4">
              Discover Career-Driven <span>Study Options </span>That Empower
              Your Ambitions
            </h2>
            {/* <h3 className="modern-subtitle mb-3">
              Empowering Minds Through Industry-Relevant Education
            </h3> */}
            <p className="programs-description">
              ISBM University offers a wide range of academic programs that
              combine theoretical foundations with real-world applications. From
              undergraduate to doctoral levels, our curriculum is designed to
              equip students with the necessary skills to thrive in a
              competitive global environment.
            </p>

            <p className="programs-description">
              Every program emphasizes research, innovation, and holistic
              development. Our faculty members are industry experts and scholars
              who ensure that students are exposed to the latest trends and
              practices. Whether it’s engineering, management, law, or liberal
              arts, students receive mentorship and opportunities for hands-on
              learning and entrepreneurship.
            </p>

            <div className="arrow-container">
              <img src={arrowImage} alt="Arrow" className="arrow-image" />
              <a href="/all-courses" target="_blank" className="view-all-link">
                View All Programs →
              </a>
            </div>
          </Col>

          <Col md={6}>
            <Row className="m-0">
              <Col md={6} className="d-flex flex-column justify-content-center">
                <div className="py-3">
                  <ProgramCard
                    title="Research and Development"
                    image={Research}
                    link="/research"
                  />
                </div>
                <div className="py-3">
                  <ProgramCard title="Post Graduation" image={Post} link="/post-graduate-programmes" />
                </div>
              </Col>
              <Col md={6} className="justify-content-between">
                <div className="py-3">
                  <ProgramCard title="Graduation" image={Graduation} link="/graduate-programmes" />
                </div>
                <div className="py-3">
                  <ProgramCard title="Diploma" image={diploma} link="/diploma-programmes" />
                </div>
                <div className="py-3">
                  <ProgramCard
                    title="Certificate"
                    image={Certificate}
                    link="/certificate-programmes"
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  );
};

// Card Component
const ProgramCard = ({ title, image, link }) => (
  <div className="program-card" style={{ backgroundImage: `url(${image})` }}>
    <div className="program-card-body">
      <h3 className="card-title">{title}</h3>
      <a href={link} target={link.target || "/"} className="btn btn-outline-light btn-sm">
        View Program <i className="ml-1 rt rt-arrow-right-regular"></i>
      </a>
    </div>
  </div>
);

export default Programs;
